export default __webpack_public_path__ + "static/media/64.7206c0a4.png";